// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay-terms {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75); 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px); 
    animation: fadeIn 0.3s ease-in-out;
}

.modal-content-terms {
    background: #fff;
    padding: 25px;
    border-radius: 15px;
    max-width: 1000px;
    width: 90%;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.3);
    transform: translateY(-20px);
    animation: slideIn 0.3s ease-in-out forwards;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}


.modal-header-terms {
    display: flex;
    justify-content: center; 
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 2px solid #e0e0e0;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    text-transform: uppercase;
}

.modal-title-terms {
    font-size: 22px;
    font-weight: bold;
    color: #222;
    flex: 1 1;
    text-align: center;
}


.modal-close-terms {
    background: none;
    border: none;
    font-size: 22px;
    font-weight: bold;
    color: #555;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    position: absolute;
    right: 15px;
}

.modal-close-terms:hover {
    color: #ff4d4d;
    transform: scale(1.3);
}

.modal-body-terms {
    padding: 15px 0;
    max-height: 500px;
    overflow-y: auto;
    position: relative;
}

.modal-body-terms::-webkit-scrollbar {
    width: 8px;
}

.modal-body-terms::-webkit-scrollbar-thumb {
    background-color: #0056b3;
    border-radius: 4px;
}

.modal-body-terms::-webkit-scrollbar-track {
    background: #ddd;
}

.pdf-container-terms {
    width: 100%;
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #f9f9f9;
    border-radius: 10px;
    padding: 12px;
    box-shadow: inset 0 0 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.pdf-container-terms canvas {
    max-width: 100% !important;
    height: auto !important;
}

.pdf-container-terms::-webkit-scrollbar {
    width: 6px;
}

.pdf-container-terms::-webkit-scrollbar-thumb {
    background-color: #007bff;
    border-radius: 4px;
}

.pdf-container-terms::-webkit-scrollbar-track {
    background: #eee;
}

@media (max-width: 768px) {
    .modal-content-terms {
        width: 95%;
        max-width: 700px;
        padding: 18px;
    }
    
    .modal-title-terms {
        font-size: 20px;
    }

    .modal-body-terms {
        max-height: 400px;
    }
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideIn {
    from { transform: translateY(-20px); }
    to { transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/PdfViewer/TermsModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mCAA2B;YAA3B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,2CAA2C;IAC3C,4BAA4B;IAC5B,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,SAAO;IACP,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,4BAA4B,EAAE;IACrC,KAAK,wBAAwB,EAAE;AACnC","sourcesContent":[".modal-overlay-terms {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.75); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    backdrop-filter: blur(10px); \n    animation: fadeIn 0.3s ease-in-out;\n}\n\n.modal-content-terms {\n    background: #fff;\n    padding: 25px;\n    border-radius: 15px;\n    max-width: 1000px;\n    width: 90%;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.3);\n    transform: translateY(-20px);\n    animation: slideIn 0.3s ease-in-out forwards;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n\n.modal-header-terms {\n    display: flex;\n    justify-content: center; \n    align-items: center;\n    padding-bottom: 12px;\n    border-bottom: 2px solid #e0e0e0;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.modal-title-terms {\n    font-size: 22px;\n    font-weight: bold;\n    color: #222;\n    flex: 1;\n    text-align: center;\n}\n\n\n.modal-close-terms {\n    background: none;\n    border: none;\n    font-size: 22px;\n    font-weight: bold;\n    color: #555;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    position: absolute;\n    right: 15px;\n}\n\n.modal-close-terms:hover {\n    color: #ff4d4d;\n    transform: scale(1.3);\n}\n\n.modal-body-terms {\n    padding: 15px 0;\n    max-height: 500px;\n    overflow-y: auto;\n    position: relative;\n}\n\n.modal-body-terms::-webkit-scrollbar {\n    width: 8px;\n}\n\n.modal-body-terms::-webkit-scrollbar-thumb {\n    background-color: #0056b3;\n    border-radius: 4px;\n}\n\n.modal-body-terms::-webkit-scrollbar-track {\n    background: #ddd;\n}\n\n.pdf-container-terms {\n    width: 100%;\n    max-height: 450px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: #f9f9f9;\n    border-radius: 10px;\n    padding: 12px;\n    box-shadow: inset 0 0 12px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.pdf-container-terms canvas {\n    max-width: 100% !important;\n    height: auto !important;\n}\n\n.pdf-container-terms::-webkit-scrollbar {\n    width: 6px;\n}\n\n.pdf-container-terms::-webkit-scrollbar-thumb {\n    background-color: #007bff;\n    border-radius: 4px;\n}\n\n.pdf-container-terms::-webkit-scrollbar-track {\n    background: #eee;\n}\n\n@media (max-width: 768px) {\n    .modal-content-terms {\n        width: 95%;\n        max-width: 700px;\n        padding: 18px;\n    }\n    \n    .modal-title-terms {\n        font-size: 20px;\n    }\n\n    .modal-body-terms {\n        max-height: 400px;\n    }\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes slideIn {\n    from { transform: translateY(-20px); }\n    to { transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
